import * as React from "react";
import type { SvyButtonProps as SvyButtonProps } from "./SvyButton.interface";
import { ElementRightContainer, ElementLeftContainer, StyledButton, LoadingContainer } from "./SvyButton.style";
import { SvyIcon } from "@/indicators";

export const SvyButton = React.forwardRef<HTMLButtonElement, SvyButtonProps>((props, ref) => {
    const { children, elementLeft, elementRight, isLoading, ...otherProps } = props;
    return (
        <StyledButton ref={ref} type="button" data-testid="svy-button" {...otherProps}>
            {elementLeft && <ElementLeftContainer>{elementLeft}</ElementLeftContainer>}
            {children}
            {isLoading && (
                <LoadingContainer data-testid="svy-button-loading-container">
                    <SvyIcon icon="loader-4-line" />
                </LoadingContainer>
            )}
            {elementRight && <ElementRightContainer>{elementRight}</ElementRightContainer>}
        </StyledButton>
    );
});

SvyButton.displayName = "SvyButton";
